import React from "react";

export default function Module_4() {
    return (
        <>
            <div className="py-4">
                <div className="row">
                    <div className="col-md-3">
                        <p style={{ textAlign: "justify" }} className="lead">
                            An emerging leader in the lighting industry with
                            representatives nationwide, DSSL works hard to
                            exceed your expectations and earn your trust every
                            day with forward-thinking product innovations,
                            proven performance and outstanding customer support.
                        </p>
                    </div>
                    <div className="col-md-1">
                        <div className="featurette-vertical-divider"></div>
                    </div>
                    <div className="col-md-7  d-flex flex-column justify-content-around fs-5 fw-normal module-4">
                        {/* <ul className="w-100 fs-4 fw-normal fst-italic">
                                <li>
                                    Reliable, American-made products
                                    <ul>
                                        <li>
                                            Custom manufacturing and design
                                            <ul>
                                                <li>
                                                    Specification-grade fixtures
                                                    <ul>
                                                        <li>
                                                            Exceptional service
                                                            and technical info
                                                            <ul>
                                                                <li>
                                                                    Solid
                                                                    warranties
                                                                    and
                                                                    after-sales
                                                                    support
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul> */}
                        <p>Reliable, American-made products</p>
                        <p>Custom manufacturing and design</p>
                        <p>Specification-grade fixtures</p>
                        <p>Exceptional service and technical info</p>
                        <p>Solid warranties and after-sales support</p>
                    </div>
                </div>
            </div>
        </>
    );
}
